import { tg } from '@infotech-soe/metaschema';
import { cloneDeep } from 'lodash';

import { DatasetGridRow } from '../../../../services/dataset/view-model/DatasetGridRow';
import { DatasetFormControlViewModel } from '../../../../services/form/view-model/FormControlViewModel';
import {
  $ROW_HIDDEN_ID,
  $ROW_HIDDEN_LABEL,
  FEATURES,
  formGridFeatures,
} from '../constants';

export const hiddenFieldsInRows = {
  add(control: DatasetFormControlViewModel): DatasetGridRow[] {
    if (!control.value?.length) {
      return [];
    }
    return (
      control.value?.map((row: DatasetGridRow, index: number) => ({
        ...row,
        ...($ROW_HIDDEN_ID in row ? {} : { [$ROW_HIDDEN_ID]: index }),
        ...(formGridFeatures.includes(FEATURES.LABEL) &&
        row[control.labelTitle || '']
          ? $ROW_HIDDEN_LABEL in row
            ? {}
            : { [$ROW_HIDDEN_LABEL]: row[control.labelTitle || ''] }
          : {}),
      })) ?? []
    );
  },

  delete(args: Record<string, any>): Record<string, any> {
    const argsWithoutHiddenfields = cloneDeep(args);
    for (const key in argsWithoutHiddenfields) {
      if (
        tg.isArray(argsWithoutHiddenfields[key]) &&
        argsWithoutHiddenfields[key][0] &&
        typeof argsWithoutHiddenfields[key][0] === 'object' &&
        $ROW_HIDDEN_LABEL in argsWithoutHiddenfields[key][0]
      ) {
        argsWithoutHiddenfields[key].forEach(
          (row: DatasetGridRow, index: number) => {
            if ($ROW_HIDDEN_LABEL in row) {
              delete argsWithoutHiddenfields[key][index][$ROW_HIDDEN_LABEL];
            }
          }
        );
      }
    }
    return argsWithoutHiddenfields;
  },
};
